export default {
  loading_menu: 'Ladataan valikkoa...',
};
